export default "__VITE_ASSET___U1diseJ__"